import { JobWorkspaceIcon } from "./icons";
import { DetailField, WorkspaceButton } from "./ui";
import { WorkspaceDrawer } from "./WorkspaceDrawer";

/**
 * Leg detail opened from a loads-and-legs row.
 * @param {{
 *   open: boolean,
 *   leg: object|null,
 *   canEdit?: boolean,
 *   onClose: () => void,
 *   onEdit: () => void,
 * }} props
 * @returns {JSX.Element}
 */
export function LegPanel({ open, leg, canEdit = false, onClose, onEdit }) {
  const record = leg || {};

  return (
    <WorkspaceDrawer
      open={open}
      title={record.label || "Leg"}
      onClose={onClose}
      footer={
        <>
          <WorkspaceButton onClick={onClose}>Close</WorkspaceButton>
          <WorkspaceButton
            tone="primary"
            disabled={!canEdit}
            onClick={onEdit}
            icon={<JobWorkspaceIcon name="pencil" />}
          >
            Edit leg
          </WorkspaceButton>
        </>
      }
    >
      <div className="flex flex-col gap-5">
        <DetailField label="Load" value={record.loadNumber || "Not provided"} />
        <DetailField
          label="Route"
          value={record.route || "Not provided"}
          detail={record.routeDetail || ""}
        />
        <DetailField label="Driver" value={record.driver || "Not provided"} />
        <DetailField label="Leg status" value={record.status || "Not provided"} />
      </div>
    </WorkspaceDrawer>
  );
}
